/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useMeetClassificationFlatData from '../../../state/meet/meetClassificationFlat/UseMeetClassificationFlatData';

const useMeetClassificationMultiSelect = () => {
  const { meetClassificationFlatState, getMeetClassificationFlat } = useMeetClassificationFlatData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (meetClassificationFlatState.isArrayLoading === false && meetClassificationFlatState.isArrayLoaded === false) {
      getMeetClassificationFlat(false, false, false);
    } else if (meetClassificationFlatState.isArrayLoading === false && meetClassificationFlatState.isArrayLoaded === true) {
      const meetClassificationOptions = [];

      for (const meetClassification of meetClassificationFlatState.arrayData) {
        if (meetClassification.parentId === null) {
          meetClassificationOptions.push({ id: meetClassification.meetClassificationId, name: meetClassification.typeName });
        }
      }

      setOptions(meetClassificationOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetClassificationFlatState]);

  return {
    meetClassificationFlatState,
    options
  };
};

export default useMeetClassificationMultiSelect;